// --- CREATE FILE: ./my-project/src/stores/modal.js ---
import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useModalStore = defineStore('modal', () => {
  const isOpen = ref(false)
  const type = ref('alert') // 'alert', 'confirm', 'error', 'success', 'prompt'
  const title = ref('')
  const message = ref('')
  const inputValue = ref('') // For prompt type
  const inputPlaceholder = ref('')
  const confirmText = ref('OK')
  const cancelText = ref('Cancel')
  const resolvePromise = ref(null)

  // --- Actions ---

  function reset () {
    type.value = 'alert'
    title.value = ''
    message.value = ''
    inputValue.value = ''
    inputPlaceholder.value = ''
    confirmText.value = 'OK'
    cancelText.value = 'Cancel'
    resolvePromise.value = null
  }

  function show ({
    mode = 'alert',
    title: t,
    message: m,
    confirmLabel = 'OK',
    cancelLabel = 'Cancel',
    placeholder = ''
  }) {
    reset()
    isOpen.value = true
    type.value = mode
    title.value = t
    message.value = m
    confirmText.value = confirmLabel
    cancelText.value = cancelLabel
    inputPlaceholder.value = placeholder

    return new Promise((resolve) => {
      resolvePromise.value = resolve
    })
  }

  // Convenience methods
  function alert (message, title = 'Information') {
    return show({ mode: 'alert', title, message, confirmLabel: 'OK' })
  }

  function error (message, title = 'Error') {
    return show({ mode: 'error', title, message, confirmLabel: 'Close' })
  }

  function success (message, title = 'Success') {
    return show({ mode: 'success', title, message, confirmLabel: 'Great!' })
  }

  function confirm (message, title = 'Are you sure?', confirmLabel = 'Yes', cancelLabel = 'Cancel') {
    return show({ mode: 'confirm', title, message, confirmLabel, cancelLabel })
  }

  function prompt (message, title = 'Input Required', placeholder = '', confirmLabel = 'Submit') {
    return show({ mode: 'prompt', title, message, placeholder, confirmLabel })
  }

  // --- Handlers ---

  function handleConfirm () {
    isOpen.value = false
    if (resolvePromise.value) {
      if (type.value === 'prompt') {
        resolvePromise.value(inputValue.value)
      } else {
        resolvePromise.value(true)
      }
    }
  }

  function handleCancel () {
    isOpen.value = false
    if (resolvePromise.value) {
      resolvePromise.value(false) // or null for prompt
    }
  }

  return {
    isOpen,
    type,
    title,
    message,
    inputValue,
    inputPlaceholder,
    confirmText,
    cancelText,
    alert,
    confirm,
    error,
    success,
    prompt,
    handleConfirm,
    handleCancel
  }
})
